import { DraggableAttributes } from "@dnd-kit/core";
import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { createContext } from "react";

import { IStationRouteDto, IStationRouteProps } from "@ryde/shared";

import { IUseStationRouteStationCtxProvider } from "../hooks";

export interface IStationRouteStationContext
  extends
    Partial<IUseStationRouteStationCtxProvider>,
    Partial<IStationRouteProps> {
  stationRouteDto?: IStationRouteDto;
  isDragging: boolean;
  listeners?: SyntheticListenerMap;
  attributes?: DraggableAttributes;
  isDragReorderAllowed?: boolean;
}
export const StationRouteStationContext =
  createContext<IStationRouteStationContext>({
    stationRouteDto: undefined,
    isDragging: false,
  });
